import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router";

import * as Api from "@/api";
import FabBar from "@/design/components/FabBar";
import MasterListVirtualized from "@/design/components/MasterListVirtualized";
import { disableSearch, enableSearch } from "@/store/reducers/ui";
import useSearch from "@/utils/hooks/useSearch";
import { toggleLoadingState } from "@/utils/utility";
import Valkyrie, { viPlus, viProhibited } from "@sippy-platform/valkyrie";

import { useMediaQuery, useTheme } from "@mui/material";
import Button from "@mui/material/Button";

function BloklistList() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const blocklistStore = useSelector((state) => state.domain.blocklists);
  const searchValue = useSelector((state) => state.ui.searchValue);
  const progressBar = useSelector((state) => state.ui.progressBar);

  // Search every time blocklistList or searchQuery changes
  const searchResults = useSearch(blocklistStore.list, searchValue, ["name", "prefix"]);

  useEffect(() => {
    toggleLoadingState(true);
    Promise.resolve(Api.getBlocklists()).finally(toggleLoadingState);
  }, []);

  // Open first item or new if the viewport is large enough
  useEffect(() => {
    if (!id && matchesMdUp && blocklistStore.meta.lastFetched) {
      if (blocklistStore.list.length >= 1) {
        navigate(`${blocklistStore.list[0].id}`);
      } else {
        navigate("new");
      }
    }
  }, [id, matchesMdUp, navigate, blocklistStore.list, blocklistStore.meta.lastFetched]);

  useEffect(() => {
    dispatch(enableSearch());
  }, [dispatch]);
  useEffect(() => () => dispatch(disableSearch()), [dispatch]);

  return (
    <>
      <MasterListVirtualized
        fabBar
        title="Blocklist"
        aria-label="Blocklist list"
        id="blocklist-list"
        list={searchResults}
        listItemProps={{
          primary: (x) => x.name,
          secondary: (x) => (x.type === "user" ? "User" : "PBX"),
          to: (x) => `../${x.id}`,
          selected: (x) => x.id === Number(id),
          icon: viProhibited,
        }}
        hideContentLoader={blocklistStore.meta.count >= 1 && searchResults.length >= 1}
        contentLoaderProps={{
          count: blocklistStore.meta.count,
          loading: progressBar,
          noItems: "You don't have any blocklists yet",
          noResults: "No blocklists in your current query",
          fetching: "Getting your blocklists",
          icon: viProhibited,
        }}
      />
      <FabBar>
        <Button variant="contained" component={NavLink} to="new" startIcon={<Valkyrie icon={viPlus} />}>
          Add
        </Button>
      </FabBar>
    </>
  );
}

export default BloklistList;
